import { render, staticRenderFns } from "./damagesExtraDetails.pug?vue&type=template&id=eb3ed94e&lang=pug&external"
import script from "./damagesExtraDetails.js?vue&type=script&lang=js&external"
export * from "./damagesExtraDetails.js?vue&type=script&lang=js&external"
import style0 from "./damagesExtraDetails.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\selfcare\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb3ed94e')) {
      api.createRecord('eb3ed94e', component.options)
    } else {
      api.reload('eb3ed94e', component.options)
    }
    module.hot.accept("./damagesExtraDetails.pug?vue&type=template&id=eb3ed94e&lang=pug&external", function () {
      api.rerender('eb3ed94e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Damage/views/damagesExtraDetails/index.vue"
export default component.exports